export default __webpack_public_path__ + "static/media/language.d4c86add.svg";